<template>
  <div id="app">
    <div class="overlay" v-if="!isOnline">Vous êtes hors ligne</div>
    <v-app :dark="env === 'development'">
      <div class="overlay overlay-doc" v-if="pdfToShow != null">
        <v-toolbar
          dark
          color="primary"
          style="z-index: 100000; overflow-x: auto"
        >
          <v-toolbar-title class="white--text">Document</v-toolbar-title>

          <v-spacer />

          <v-btn icon>
            <v-icon
              color="white"
              @click.stop="previous"
              :disabled="!hasPrevious"
              class="arrow"
              >arrow_left</v-icon
            >
          </v-btn>

          <v-btn icon>
            <v-icon
              color="white"
              class="arrow"
              :disabled="!hasNext"
              @click.stop="next"
              >arrow_right</v-icon
            >
          </v-btn>

          <v-btn icon>
            <v-icon color="white" class="arrow" @click.stop="hidePDF()"
              >close</v-icon
            >
          </v-btn>
        </v-toolbar>

        <pdfvuer
          v-if="pdfToShow != null"
          :src="pdfdata"
          :page="page"
          :scale="'page-width'"
          :resize="true"
          @click.stop="noop"
        >
          <template slot="loading">
            <div class="loader">
              <v-progress-circular :size="100" color="green" indeterminate />
            </div>
          </template>
        </pdfvuer>
      </div>
      <v-snackbar
        v-model="newVersionAvailable"
        :multi-line="true"
        :timeout="0"
        class="new-version-snackbar"
      >
        <span
          ><p>Une nouvelle version du site est disponible.</p>
          <p>
            Il est recommandé de rafraichir le site une fois votre travail en
            cours achevé.
          </p></span
        ><v-btn flat color="primary" @click="refreshSite">Rafraichir</v-btn></v-snackbar
      >
      <component
        :style="{ display: pdfToShow ? 'none' : 'initial' }"
        :is="layout"
      >
        <router-view />
      </component>
    </v-app>
  </div>
</template>

<script>
import DefaultLayout from "./views/layouts/Default";
import EmptyLayout from "./views/layouts/Empty";
import { fetchHil, fetchHil2 } from "./utils";
import { mapActions, mapState } from "vuex";
import Pdfvuer from "pdfvuer";

export default {
  components: { Pdfvuer, DefaultLayout, EmptyLayout },
  data() {
    return {
      page: 1,
      numPages: 0,
      pdfdata: undefined,
      isOnline: true
    };
  },
  computed: {
    ...mapState("ui", ["pdfToShow", "newVersionAvailable"]),
    env() {
      return process?.env?.NODE_ENV;
    },
    layout() {
      return (this.$route.meta.layout || "default") + "-layout";
    },
    hasPrevious() {
      return this.page > 1;
    },
    hasNext() {
      return this.page < this.numPages;
    }
  },
  timers: {
    onlinecheck: { time: 5000, autostart: true, repeat: true },
    versioncheck: {
      time: /* 10 minutes */ 1000 * 60 * 10,
      autostart: true,
      repeat: true,
      immediate: true
    }
  },
  watch: {
    pdfToShow: function(s) {
      if (s) {
        this.showPDFInner();
      }
    }
  },
  methods: {
    ...mapActions("ui", ["showPDF", "changePage", "setLastKnownVersion"]),

    showPDFInner() {
      var self = this;
      self.page = 1;
      self.numPages = 1;
      self.pdfdata = Pdfvuer.createLoadingTask(this.pdfToShow);
      window.scrollTo(0, 0);
      self.pdfdata.then(pdf => {
        self.numPages = pdf.numPages;
        window.scrollTo(0, 0);
      });
    },

    async onlinecheck() {
      if (!process.env.CORDOVA_PLATFORM) {
        return;
      }
      try {
        const resp = await fetchHil("/status.json");
        this.isOnline = resp.ok;
      } catch (e) {
        this.isOnline = false;
      }
    },
    async versioncheck() {
      if (this.newVersionAvailable) {
        return; // No need to check for a new version if we already know there is one
      }

      try {
        const resp = await fetchHil2("get", "/release.json");
        this.setLastKnownVersion(resp.ts);
      } catch (e) {
        // Ignore it
        console.error(e);
      }
    },
    refreshSite() {
      window.location.reload();
    },
    next() {
      if (this.hasNext) {
        this.page++;
      }
    },
    previous() {
      if (this.hasPrevious) {
        this.page--;
      }
    },
    hidePDF() {
      this.showPDF({
        data: null
      });
    },
    noop() {}
  }
};
</script>

<style>
.overlay {
  position: absolute;
  top: 0;
  height: 100vh;
  left: 0;
  width: 100vw;
  background: rgba(100, 100, 100, 1);
  z-index: 10000000;
  color: white;
  font-size: 28pt;
  font-family: "Roboto";
}

.overlay-doc {
  padding: 0;
}

.loader {
  position: fixed;
  top: 0;
  height: 100vh;
  left: 0;
  width: 100vw;
  z-index: 200000;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.new-version-snackbar {
  text-align: justify;
}

.new-version-snackbar p {
  margin: 2px;
}
</style>
